module.exports = __webpack_public_path__ + "img/5.2674c16c.jpg";